<template>
	<div class="uasdi3ka" :class="[size, status]">
		<!-- Button - -->
		<div
			class="button"
			:class="{ 'button--disabled': parseFloat(computedValue) === min }"
			tabindex="0"
			@click="decrease"
			@blur="$emit('blur')"
			@focus="$emit('focus')"
			@keyup.enter="decrease"
		>
			-
		</div>

		<!-- Middle -->
		<div class="number">{{ computedValue }}</div>

		<!-- Button + -->
		<div
			class="button"
			:class="{ 'button--disabled': parseFloat(computedValue) === max }"
			tabindex="0"
			@click="increase"
			@blur="$emit('blur')"
			@focus="$emit('focus')"
			@keyup.enter="increase"
		>
			+
		</div>
	</div>
</template>

<script>
export default {
	name: "j-base-input-number-stepper",

	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return (
					val === null || typeof val === "string" || typeof val === "number"
				)
			}
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					["xsmall", "small", "medium", "large", "xlarge"].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return val === null || ["error", "success", "warning"].includes(val)
			}
		},
		min: {
			type: Number,
			required: true,
			default: 0
		},
		max: {
			type: Number,
			required: true,
			default: 10
		},
		step: {
			type: Number,
			required: true,
			default: 1
		},
		decimalPlaces: {
			type: Number,
			required: false,
			default: 0
		}
	},

	computed: {
		computedValue() {
			if (!this.value) return parseFloat(this.min).toFixed(this.decimalPlaces)
			return parseFloat(this.value).toFixed(this.decimalPlaces)
		}
	},

	methods: {
		decrease() {
			let value = parseFloat(this.value)
			value = isNaN(value) ? this.min : value
			value = value - this.step

			// If value is lower than min, show min
			if (value < this.min) value = this.min

			this.$emit("input", parseFloat(value.toFixed(this.decimalPlaces)))
		},

		increase() {
			let value = parseFloat(this.value)
			value = isNaN(value) ? this.min : value
			value = value + this.step

			// If value is lower than max, show max
			if (value > this.max) value = this.max

			this.$emit("input", parseFloat(value.toFixed(this.decimalPlaces)))
		}
	}
}
</script>
<style src="./index.css" scoped />
